import React, { useEffect, useState } from 'react';
import axios from 'axios';
import sideMenuCss from "./AdminSideMenu.module.css"
import logoImg from "../../../images/bubble-logo.png"
import { useNavigate, useLocation } from 'react-router-dom';
import { ButtonOutlineGreenWithDiffStyle } from '../Buttons/Buttons';
import { Link } from 'react-router-dom';
import { 
    Redeem, 
    Group, 
    AdminPanelSettings,
    ReceiptLong,
    Analytics,
    ConnectWithoutContact,
    RateReview,
    Security,
    School
} from '@mui/icons-material';
const screenWidth = window.innerWidth

const AdminSideMenu = () => {
    const navigate = useNavigate();
    const location = useLocation();
    let specificPath = location.pathname.slice(8)
    const [role, setRole] = useState('');
    
    useEffect (() => {
        if (screenWidth <= 900) {
            const adminMenuCont = document.getElementById('admin-menu-container');
            adminMenuCont.classList.add(sideMenuCss["side-menu-minimized"])
        }
    }, [location])

    useEffect(() => {
        // Fetch current admin role for menu gating
        const token = sessionStorage?.getItem('afd8TvhsdjwiuuvsgjhsAfgsUhjs');
        (async () => {
            try {
                const resp = await axios.get('/origin/get-current-admin', { headers: { 'x-access-token': token } });
                setRole(resp?.data?.role || '');
            } catch {
                setRole('');
            }
        })();
    }, []);


    const handleMouseEnter = () => {
        if (screenWidth <= 900) {
            const adminMenuCont = document.getElementById('admin-menu-container');
            adminMenuCont.classList.remove(sideMenuCss["side-menu-minimized"]);
        }
    }

    const handleMouseLeave = () => {
        if (screenWidth <= 900) {
            const adminMenuCont = document.getElementById('admin-menu-container');
            adminMenuCont.classList.add(sideMenuCss["side-menu-minimized"]);
        }
    }

    const handleAdminLogOut = () => {
        sessionStorage?.removeItem('afd8TvhsdjwiuuvsgjhsAfgsUhjs')
        navigate("/")
    }


    return (
        <div id='admin-menu-container' className={sideMenuCss.AdminSideMenu} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>

            <div className={sideMenuCss.Logo}>
                <Link to='/'>
                    <img src={logoImg} alt='Bubble Ai' style={{width: "90%"}} />
                </Link>
            </div>
            
            <hr></hr>
            <ul className={sideMenuCss.SideMenuItems}>
                {(role === 'superadmin' || role === 'admin') && (
                    <li className={specificPath === "analytics" ? sideMenuCss.Active : ""}>
                        <Link to="/origin/dashboard/analytics">
                            <Analytics />
                            <span>Analytics Board</span>
                        </Link>
                    </li>
                )}
                {(role === 'superadmin' || role === 'admin' || role === 'support') && (
                    <li className={specificPath === "anti-abuse" ? sideMenuCss.Active : ""}>
                        <Link to="/origin/dashboard/anti-abuse">
                            <Security />
                            <span>Anti‑Abuse</span>
                        </Link>
                    </li>
                )}
                {(role === 'superadmin' || role === 'admin' || role === 'support') && (
                    <li className={specificPath === "referrals" ? sideMenuCss.Active : ""}>
                        <Link to="/origin/dashboard/referrals">
                            <ConnectWithoutContact />
                            <span>Referrals</span>
                        </Link>
                    </li>
                )}
                {(role === 'superadmin' || role === 'admin' || role === 'support') && (
                    <li className={specificPath === "testimonials" ? sideMenuCss.Active : ""}>
                        <Link to="/origin/dashboard/testimonials">
                            <RateReview />
                            <span>Testimonials</span>
                        </Link>
                    </li>
                )}
                {(role === 'superadmin' || role === 'admin' || role === 'support') && (
                    <li className={specificPath === "transactions" ? sideMenuCss.Active : ""}>
                        <Link to="/origin/dashboard/transactions">
                            <ReceiptLong />
                            <span>Transactions</span>
                        </Link>
                    </li>
                )}
                {(role === 'superadmin' || role === 'support') && (
                    <li className={specificPath === "users" ? sideMenuCss.Active : ""}>
                        <Link to="/origin/dashboard/users">
                            <Group />
                            <span>Users</span>
                        </Link>
                    </li>
                )}
                {role === 'superadmin' && (
                    <li className={specificPath === "coupons" ? sideMenuCss.Active : ""}>
                        <Link to="/origin/dashboard/coupons">
                            <Redeem />
                            <span>Coupons</span>
                        </Link>
                    </li>
                )}
                {role === 'superadmin' && (
                    <li className={specificPath === "admins" ? sideMenuCss.Active : ""}>
                        <Link to="/origin/dashboard/admins" >
                            <AdminPanelSettings />
                            <span>Admin Settings</span>
                        </Link>
                    </li>
                )}
                {(role === 'superadmin' || role === 'admin') && (
                    <li className={specificPath === "schools" ? sideMenuCss.Active : ""}>
                        <Link to="/origin/dashboard/schools">
                            <School />
                            <span>Schools</span>
                        </Link>
                    </li>
                )}
            </ul>

            <div style={{ marginTop: "40px"}}>
                <ButtonOutlineGreenWithDiffStyle onClick={handleAdminLogOut}>
                    Log out
                </ButtonOutlineGreenWithDiffStyle>
            </div>
        </div>
    );
};

export default AdminSideMenu;
